import { render, staticRenderFns } from "./showSpeakersEdition.vue?vue&type=template&id=241dc852"
import script from "./showSpeakersEdition.vue?vue&type=script&lang=js"
export * from "./showSpeakersEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports